/*
 * Take It Apart product story (sections/ps-u2ta-*.liquid).
 * - one-shot "in view" reveals for the small diagrams (.ta-anim)
 * - manual-mode dials
 * - the pinned exploded drawing that assembles as you scroll, and its
 *   labelled part rail (tap to jump; chapters can be switched off)
 * - in-page Add to cart buttons that press the buy box's real button
 * - caps the Judge.me widget until "See all reviews" (ps-u2ta-proof)
 * Without JS (or with reduced motion) every diagram shows its finished state.
 */
(function () {
  if (window.__u2ta) return;
  window.__u2ta = true;

  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in window;

  function init() {
    var roots = [].slice.call(document.querySelectorAll('.u2ta'));
    if (!roots.length) return;
    roots.forEach(function (r) {
      r.classList.add('is-js');
      if (RM) r.classList.add('is-rm');
    });

    /* one-shot reveals */
    var anims = [].slice.call(document.querySelectorAll('.u2ta .ta-anim'));
    if (RM || !IO) anims.forEach(function (a) { a.classList.add('in'); });
    else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
      }, { threshold: 0.35, rootMargin: '0px 0px -12% 0px' });
      anims.forEach(function (a) { io.observe(a); });
    }

    /* manual-mode dials: sweep to their setting when seen, replay on tap */
    var setDial = function (b, v) { b.querySelector('.ta-val').style.strokeDashoffset = String(1 - v); };
    document.querySelectorAll('.u2ta .ta-dials').forEach(function (dials) {
      var btns = [].slice.call(dials.querySelectorAll('button'));
      btns.forEach(function (b) {
        b.addEventListener('click', function () { setDial(b, 0); setTimeout(function () { setDial(b, +b.dataset.v); }, 380); });
      });
      var go = function () { btns.forEach(function (b) { setDial(b, +b.dataset.v); }); };
      if (RM || !IO) return go();
      btns.forEach(function (b) { setDial(b, 0); });
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (x) { if (x.isIntersecting) { go(); o.disconnect(); } });
      }, { threshold: 0.5 });
      o.observe(dials);
    });

    /* in-page Add to cart: press the buy box's own button so the cart drawer,
       analytics and variant logic all behave exactly as usual */
    document.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-u2ta-atc]');
      if (!t) return;
      ev.preventDefault();
      var btn = document.querySelector('[id$="__main"] form[action*="/cart/add"] [name="add"]') ||
        document.querySelector('form[action*="/cart/add"] [name="add"]');
      if (btn && !btn.disabled) btn.click();
      else if (btn) btn.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
    });

    initReviewsCap();
    document.querySelectorAll('.u2ta-story').forEach(initStory);
  }

  /* ---------------------------------------------------------------- reviews */
  function initReviewsCap() {
    var proof = document.querySelector('.u2ta-proof[data-cap-reviews]');
    if (!proof) return;
    var tries = 0;
    (function find() {
      var w = document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget, #judgeme_product_reviews');
      var sec = w && w.closest('.shopify-section');
      if (!sec) { if (++tries < 20) setTimeout(find, 500); return; }
      var more = null, opened = false;
      var open = function () { opened = true; sec.classList.remove('ta-rv-cap'); if (more) more.remove(); };
      // Judge.me fills the widget after load, so cap it once it grows tall
      var cap = function () {
        if (opened || more || sec.scrollHeight < 1300) return;
        sec.classList.add('ta-rv-cap');
        more = document.createElement('button');
        more.type = 'button';
        more.className = 'ta-rv-more';
        more.textContent = proof.getAttribute('data-cap-label') || 'See all reviews';
        sec.insertAdjacentElement('afterend', more);
        more.addEventListener('click', open);
      };
      cap();
      // Judge.me swaps its widget node when it finishes setup, so watch the section
      if ('ResizeObserver' in window) new ResizeObserver(cap).observe(sec);
      var polls = 0;
      var poll = setInterval(function () { cap(); if (more || opened || ++polls > 30) clearInterval(poll); }, 500);
      proof.querySelectorAll('[data-u2ta-reviews]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault(); open();
          sec.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
        });
      });
    })();
  }

  /* ---------------------------------------------------------------- the exploded drawing */
  function initStory(ta) {
    var stage = ta.querySelector('.ta-stage');
    var svg = stage && stage.querySelector('.ta-ghost');
    if (!svg || typeof svg.getBBox !== 'function') return;
    var tag = stage.querySelector('.ta-tag');
    var railList = stage.querySelector('.ta-rail ol');
    var rail = [].slice.call(stage.querySelectorAll('.ta-rail button'));
    var chapters = [].slice.call(ta.querySelectorAll('.ta-ch'));
    // chapters can be switched off in the theme editor: each one knows its part (k)
    var K = chapters.map(function (c) { return +c.getAttribute('data-k'); });
    var render = svg.querySelector('.ta-render');
    var pin = svg.querySelector('.ta-pin');
    var axes = svg.querySelector('.ta-axes');
    var NS = 'http://www.w3.org/2000/svg';
    var header = document.querySelector('.shopify-section-header, sticky-header');

    // dx/dy: exploded offset from the assembled position (render pixels); r: float tilt
    var P = [
      { id: 'ring', k: 1, dx: 0, dy: -70 },
      { id: 'jar', k: 2, dx: 0, dy: -150 },
      { id: 'blade', k: 3, dx: 0, dy: -412 },
      { id: 'lid', k: 4, dx: 0, dy: -255, r: -4 },
      { id: 'crown', k: 4, dx: 0, dy: -318, lag: 0.3 },
      { id: 'scale', k: 5, dx: 10, dy: -150, r: 3 },
      { id: 'screen', k: 6, dx: 95, dy: 28, r: 7 },
      { id: 'knob', k: 7, dx: 178, dy: 52 },
      { id: 'phone', k: 8, dx: 70, dy: -285, r: 9 }
    ];
    var NUM = { ring: 1, jar: 2, blade: 3, lid: 4, scale: 5, screen: 6, knob: 7, phone: 8 };
    var OFF = { ring: [-44, 4], blade: [-40, 0], lid: [-30, 0], knob: [20, -22], phone: [-24, -6], scale: [0, -16] };
    var badges = svg.querySelector('.ta-badges');
    var base = svg.querySelector('#gp-base');

    try {
      P.forEach(function (p) {
        p.el = svg.querySelector('#gp-' + p.id);
        var b = p.el.getBBox();
        p.b = { x: b.x, y: b.y, w: b.width, h: b.height, cx: b.x + b.width / 2, cy: b.y + b.height / 2 };
        p.ax = document.createElementNS(NS, 'line');
        p.ax.setAttribute('class', 'ax');
        axes.appendChild(p.ax);
        if (NUM[p.id]) {
          var g = document.createElementNS(NS, 'g');
          g.setAttribute('class', 'ta-badge');
          g.innerHTML = '<circle r="11"/><text y="0.5">' + NUM[p.id] + '</text>';
          badges.appendChild(g);
          p.badge = g;
        }
        var pt = p.el.querySelector('[data-pin]');
        p.pin = pt ? { x: +pt.getAttribute('cx'), y: +pt.getAttribute('cy') } : { x: p.b.cx, y: p.b.cy };
      });
    } catch (e) { return; }

    var bb = base.getBBox();
    var baseBox = { x: bb.x, y: bb.y, w: bb.width, h: bb.height };
    var UNIT = { x: -18, y: 52, w: 744, h: 588 }; // unit only (payoff framing)
    var clamp = function (v, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.min(b, Math.max(a, v)); };
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
    var lerp = function (a, b, t) { return a + (b - a) * t; };
    var phone = P[P.length - 1];
    var ticking = false;

    function headerOffset() {
      if (!header) return 0;
      var r = header.getBoundingClientRect();
      return r.bottom > 0 && r.top <= 1 ? Math.round(r.bottom) : 0;
    }

    // q: -1 before the first chapter, then i + fraction through chapter i
    function chapterProgress() {
      var sb = stage.getBoundingClientRect().bottom;
      var line = sb + (innerHeight - sb) * 0.6;
      var q = -1;
      chapters.forEach(function (c, i) {
        var r = c.getBoundingClientRect();
        if (r.top < line) q = i + clamp((line - r.top) / r.height);
      });
      return q;
    }

    // p: part progress, 0..9 (part k lands between k-1 and k). A switched-off
    // chapter's part lands during the visible chapter before it.
    function partProgress(q) {
      if (q < 0) return -1;
      var i = Math.min(chapters.length - 1, Math.floor(q));
      var from = i === 0 ? 0 : K[i] - 1;
      var to = i + 1 < chapters.length ? K[i + 1] - 1 : K[i];
      return from + (to - from) * (q - i);
    }

    // tap a part in the rail: bring its chapter heading up just under the drawing
    function goTo(k) {
      var i = K.indexOf(k);
      if (i < 0) return;
      var y = scrollY + chapters[i].getBoundingClientRect().top - headerOffset() - stage.offsetHeight + 2;
      scrollTo({ top: Math.max(0, y), behavior: RM ? 'auto' : 'smooth' });
    }
    rail.forEach(function (b) {
      b.addEventListener('click', function () { goTo(+b.getAttribute('data-go')); });
    });
    var lastOn = -2;

    function update() {
      ticking = false;
      ta.style.setProperty('--ta-top', headerOffset() + 'px');
      var q = chapterProgress();
      var p = partProgress(q);
      var ci = q < 0 ? -1 : Math.min(chapters.length - 1, Math.floor(q));
      var active = ci < 0 ? 0 : K[ci]; // part number in focus, 9 = payoff
      var lit = clamp((p - 8) / 0.25);
      var rend = RM ? (p >= 8.25 ? 1 : 0) : ease(clamp((p - 8.2) / 0.4));
      var minx = baseBox.x, miny = baseBox.y, maxx = baseBox.x + baseBox.w, maxy = baseBox.y + baseBox.h;

      P.forEach(function (o) {
        var t = RM ? 1 : clamp((p - (o.k - 1) - (o.lag || 0) * 0.45) / 0.45);
        var e = ease(t);
        var x = o.dx * (1 - e), y = o.dy * (1 - e), rot = (o.r || 0) * (1 - e);
        o.el.setAttribute('transform', 'translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ') rotate(' + rot.toFixed(2) + ' ' + o.b.cx + ' ' + o.b.cy + ')');
        o.el.classList.toggle('float', e < 0.995);
        o.el.classList.toggle('on', o.k === active && active <= 8);
        o.cur = { x: o.b.cx + x, y: o.b.cy + y };
        var show = (1 - e) > 0.02;
        o.ax.setAttribute('x1', o.cur.x); o.ax.setAttribute('y1', o.cur.y);
        o.ax.setAttribute('x2', o.b.cx); o.ax.setAttribute('y2', o.b.cy);
        o.ax.style.opacity = show ? (0.75 * (1 - e)).toFixed(2) : 0;
        if (!(o.id === 'phone' && rend > 0.5)) {
          minx = Math.min(minx, o.b.x + x); miny = Math.min(miny, o.b.y + y);
          maxx = Math.max(maxx, o.b.x + o.b.w + x); maxy = Math.max(maxy, o.b.y + o.b.h + y);
        }
      });

      // camera: fit everything on stage, easing toward the unit-only frame at the payoff
      var pad = 26;
      if (RM) {
        svg.querySelectorAll('.ta-co').forEach(function (c) {
          var b = c.getBBox();
          minx = Math.min(minx, b.x); miny = Math.min(miny, b.y);
          maxx = Math.max(maxx, b.x + b.width); maxy = Math.max(maxy, b.y + b.height);
        });
      }
      var cam = { x: minx - pad, y: miny - pad, w: maxx - minx + pad * 2, h: maxy - miny + pad * 2 };
      cam = { x: lerp(cam.x, UNIT.x, rend), y: lerp(cam.y, UNIT.y, rend), w: lerp(cam.w, UNIT.w, rend), h: lerp(cam.h, UNIT.h, rend) };
      var sw = stage.clientWidth, sh = stage.clientHeight;
      var T = 44, B = 50, S = 8; // room for the tag (top) and the rail (bottom)
      var scale = Math.min((sw - 2 * S) / cam.w, (sh - T - B) / cam.h);
      var vw = sw / scale, vh = sh / scale;
      var vx = cam.x - (vw - cam.w) / 2;
      var vy = cam.y - T / scale - ((sh - T - B) / scale - cam.h) / 2;
      svg.setAttribute('viewBox', vx.toFixed(1) + ' ' + vy.toFixed(1) + ' ' + vw.toFixed(1) + ' ' + vh.toFixed(1));

      svg.setAttribute('data-on', active);
      svg.classList.toggle('lit', lit > 0.5);
      svg.classList.toggle('phone-in', !phone.el.classList.contains('float'));
      render.style.opacity = rend.toFixed(3);
      svg.querySelectorAll('.gp').forEach(function (g) {
        g.style.opacity = g.id === 'gp-phone' ? (1 - rend).toFixed(3) : (1 - 0.9 * rend).toFixed(3);
      });
      axes.style.opacity = 1 - rend;
      svg.querySelectorAll('.ta-co').forEach(function (c) { c.style.opacity = (1 - rend).toFixed(3); });

      // numbered badges ride on the floating parts before the first one lands
      P.forEach(function (o) {
        if (!o.badge) return;
        var bx = o.pin.x + (o.cur.x - o.b.cx), by = o.pin.y + (o.cur.y - o.b.cy);
        var of = OFF[o.id] || [0, 0];
        o.badge.setAttribute('transform', 'translate(' + bx.toFixed(1) + ' ' + by.toFixed(1) + ') scale(' + (1 / scale).toFixed(3) + ') translate(' + of[0] + ' ' + of[1] + ')');
      });
      badges.classList.toggle('show', active === 0 && !RM);

      // pin on the active part, sized in screen pixels
      var a = null;
      P.forEach(function (o) { if (!a && o.k === active) a = o; });
      if (a && active <= 8) {
        var px = a.pin.x + (a.cur.x - a.b.cx), py = a.pin.y + (a.cur.y - a.b.cy);
        pin.setAttribute('transform', 'translate(' + px.toFixed(1) + ' ' + py.toFixed(1) + ') scale(' + (1 / scale).toFixed(3) + ')');
        pin.classList.add('show');
      } else pin.classList.remove('show');

      // tag + rail
      var ch = chapters[Math.max(0, ci)];
      var tb = tag.querySelector('b'), ts = tag.querySelector('span'), tm = tag.querySelector('small');
      if (active === 0) {
        tb.textContent = '0';
        ts.textContent = RM ? tag.getAttribute('data-rm-name') : tag.getAttribute('data-name');
        tm.textContent = RM ? tag.getAttribute('data-rm-meta') : tag.getAttribute('data-meta');
      } else {
        tb.textContent = ch.getAttribute('data-num');
        ts.textContent = ch.getAttribute('data-name');
        tm.textContent = ch.getAttribute('data-meta');
      }
      rail.forEach(function (b, i) {
        var on = i === ci;
        b.classList.toggle('done', i < ci);
        b.classList.toggle('on', on);
        if (on) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        b.style.setProperty('--f', i < ci ? 1 : on ? clamp(q - ci).toFixed(3) : 0);
      });
      // keep the part in focus visible in the rail (scrolls the rail, not the page)
      if (ci !== lastOn && railList) {
        lastOn = ci;
        var cur = rail[Math.max(0, ci)];
        if (cur) {
          var left = cur.offsetLeft - (railList.clientWidth - cur.offsetWidth) / 2;
          railList.scrollTo({ left: Math.max(0, left), behavior: RM ? 'auto' : 'smooth' });
        }
      }
    }

    var req = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', req, { passive: true });
    addEventListener('resize', req);
    // the sticky header reveals itself a moment after scrolling stops: follow it
    if (header && 'MutationObserver' in window) {
      new MutationObserver(function () { req(); setTimeout(req, 350); })
        .observe(header, { attributes: true, attributeFilter: ['class'] });
    }
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
